import { Capacitor, registerPlugin, type PluginListenerHandle } from '@capacitor/core'

export type NativeTabKind = 'link' | 'action'

export interface NativeTabItem {
  key: string
  label: string
  sfSymbol: string
  kind: NativeTabKind
  badge?: number
}

export interface ShowOptions {
  tabs: NativeTabItem[]
  activeKey?: string
}

export interface TabSelectedEvent {
  key: string
}

export interface NativeTabBarPlugin {
  show(options: ShowOptions): Promise<void>
  hide(): Promise<void>
  setActive(options: { key: string }): Promise<void>
  setBadge(options: { key: string; count: number | null }): Promise<void>
  setSwipeBack(options: { enabled: boolean }): Promise<void>
  addListener(
    event: 'tabSelected',
    handler: (e: TabSelectedEvent) => void
  ): Promise<PluginListenerHandle>
  addListener(
    event: 'moreSelected',
    handler: (e: TabSelectedEvent) => void
  ): Promise<PluginListenerHandle>
}

const plugin = registerPlugin<NativeTabBarPlugin>('NativeTabBar')

// On iOS we assume the plugin is compiled in. `isPluginAvailable` can return
// false for @objc auto-registered plugins in Capacitor 7 before the first
// call resolves — we handle missing-plugin errors at call sites instead.
export const isNativeTabBarAvailable = (): boolean => Capacitor.getPlatform() === 'ios'

export default plugin
